var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 107,
    viewBox: "0 0 142 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 106.24V76.1284C6 52.9286 15.9672 31.5632 23.2134 28.1967C55.5 13.1966 83 13.1966 117.257 28.6282C126.224 32.6678 134 62.1282 134 76.1284V106.24C132.847 105.394 131.503 104.766 129.948 104.393C129.983 103.045 130 101.683 130 100.306C130 53.9238 110.169 29 70 29C29.8312 29 10 53.9238 10 100.306C10 101.683 10.0175 103.045 10.0524 104.393C8.49732 104.766 7.15329 105.394 6 106.24Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.986 83.9916C77.1723 83.4655 35.3449 58.2887 34.0318 17.0114C33.9967 15.9074 34.9464 15 36.051 15C141.386 15.0027 141.998 15.429 142 81.9567C142 83.0613 141.09 84.0008 139.986 83.9916Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00573 83.9624C31.0802 82.8641 50.372 57.7979 50.985 17.0122C51.0016 15.9078 50.0682 14.9999 48.9636 15.0002C0.28574 15.0123 0.000789642 15.9085 0 81.9567C-1.14441e-05 83.0613 0.901955 84.0041 2.00573 83.9624Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0016 28.9278C49.787 27.9927 58.3078 18.0228 58.9597 2.00276C59.0047 0.899107 58.0991 -0.000473288 56.9945 0.000674621C35.4431 0.0230717 35.0085 0.78904 35.0002 26.9847C34.9998 28.0893 35.9 29.0084 37.0016 28.9278Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairF);
export default __webpack_public_path__ + "static/media/Hair F.2b13a6deec9528e146ef0a20c574bb65.svg";
export { ForwardRef as ReactComponent };